import { forwardRef, createElement } from 'react';

function IconJournalPro(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M16.737 3.668c-.055 1.093.226 2.033.894 2.7.668.669 1.608.95 2.7.897a18.08 18.08 0 01-3.09 4.184 27.666 27.666 0 01-3.127 2.706v3.318a.553.553 0 01-.162.39l-3.975 3.975a.553.553 0 01-.943-.39V18.32a.55.55 0 01.162-.39l1.24-1.24a.553.553 0 00.161-.39v-.133c-1.238.463-2.218.487-2.735-.03-.517-.517-.493-1.497-.03-2.735H7.7a.553.553 0 00-.325.105l-.066.057-1.24 1.24a.553.553 0 01-.303.154l-.087.007H2.553a.553.553 0 01-.455-.867l.064-.076 3.975-3.975a.553.553 0 01.304-.155l.086-.007h3.318a27.666 27.666 0 012.706-3.126 18.078 18.078 0 014.186-3.092zM21.93 2.07c.104.105.095.547-.048 1.212l-.083.35-.107.386-.061.204-.142.43c-.154.444-.345.928-.575 1.436-1.073.193-1.96.04-2.501-.5-.523-.523-.684-1.37-.52-2.395l.019-.107a16.762 16.762 0 011.654-.649l.416-.13.197-.055.368-.095c.76-.18 1.27-.2 1.383-.087z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var JournalPro = /*#__PURE__*/forwardRef(IconJournalPro);

export default JournalPro;
//# sourceMappingURL=JournalPro.js.map
